module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Application Status")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("After a thorough evaluation of your overall performance in the HAWO recruitment process, we regret to inform you that you did not meet our standards. We will not be moving forward with your application. While your qualifications are impressive, our selection process is highly competitive.")]), _vm._v(" "), _c('p', [_vm._v("Thank you for your interest, and we wish you all the best in your future endeavors.")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("HAWO Recruitment Team")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40b49bdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/online_failed.vue
// module id = 836
// module chunks = 1